import React from "react";
import { TextField, Button } from "@mui/material";

export default function TextFieldWithCounter(props) {
    const CHARACTER_LIMIT = 255;
    const [values, setValues] = React.useState({
        name: ""
    });

    const [comment, setComment] = React.useState("");

    const handleChange = name => event => {
        setValues({ ...values, [name]: event.target.value });
        setComment(event.target.value);
    };

    const handleClick = name => event => {
        if (comment !== "") {
            props.errorCallback(false);
            fetch("/api/commentsweb/" + props.discussRec.discussionIdentifier + "/" + props.userIdentifier, {
                method: "POST",
                headers: {
                    "ClientIdentifier": props.discussRec.loan.clientIdentifier,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(comment)
            })
                .then(response => response.json())
                .then(json => console.log(json))
                .catch((error) => {
                    console.error('There has been a problem with your POST operation:', error);
                });
            setValues({ [name]: "" }, event.target.value);
            setComment(event.target.value);
            setTimeout(function () {
                props.parentCallback();
            }, 1000);
        }
        else {
            props.errorCallback(true);
        }
    };

    return (
        <div>
            <TextField
                required
                fullWidth
                margin="normal"
                id="comment"
                name="comment"
                label="Required"
                inputProps={{
                    maxLength: CHARACTER_LIMIT
                }}
                multiline
                helperText={`${values.name.length}/${CHARACTER_LIMIT}`}
                onChange={handleChange("name")}
                variant="outlined"
                value={comment}
                disabled={props.discussRec.isDecisioned || !props.docLoaded}
            />
            <Button
                name="newComment"
                size="small"
                onClick={handleClick("name")}
                disabled={props.discussRec.isDecisioned || !props.docLoaded}
            >+ Comment
            </Button>
        </div>
    );
}